import { GetServerSideProps, GetServerSidePropsContext } from "next/types";

import { useEffect } from "react";

import {
  deepMergeObjects,
  getDeviceIdForServer,
  replaceHistory,
} from "@tm/insurance/utils";
import { PARTNER } from "@tm/isomorphic-utils";
import { getCommonsHeaderData } from "@tm/server-api-utils";
import { getPartnerOnServerSide } from "@tm/server-utils";
import "pwa-mmt-ui-header/ssr/header.css";
import LandingPage from ".";
import { getSeoLandingPageDetailsByCountry } from "../../src/api";
import { SEO_PAGES_QUERY_ID } from "../../src/api/constants";
import { seoGSSP } from "../../src/utils/seoGSSP";
import { conditionallyLoadWebVitals } from "../../src/utils/webVitals";

export function CountryLandingPage(props) {
  const { data } = props || {};

  useEffect(() => {
    if (data?.countryCode) {
      const searchParams = new URLSearchParams(window.location.search);
      const currentCountryCode = searchParams.get("countries");

      if (!currentCountryCode) {
        replaceHistory("countries", data.countryCode);
      }
    }
  }, [data]);

  useEffect(() => {
    conditionallyLoadWebVitals();
  }, []);

  return <LandingPage {...props} />;
}

const getLandingPageJsonByCountry = async (country, partner) => {
  try {
    const response = await getSeoLandingPageDetailsByCountry(country, partner);
    const defaultJSON = response?.find(
      (json) =>
        json?.type ===
        (partner === PARTNER.GI
          ? SEO_PAGES_QUERY_ID.LANDING_PAGE_COUNTRY_GI
          : SEO_PAGES_QUERY_ID.LANDING_PAGE_COUNTRY)
    );
    const countryJSON = response?.find(
      (json) =>
        json?.type ===
        `seo-insurance${
          partner === PARTNER.GI ? `-${partner}` : ""
        }-landing-${country}`
    );

    const countryName = countryJSON?.data?.travelCountry;

    const mergedJSON = deepMergeObjects(defaultJSON, countryJSON);

    const jsonWithCountry = JSON.stringify(mergedJSON)?.replace(
      /{travelCountry}/g,
      countryName
    );

    return jsonWithCountry ? JSON.parse(jsonWithCountry) : null;
  } catch (error) {
    console.error({ error });
    throw error;
  }
};

export const getServerSideProps: GetServerSideProps = async (
  ctx: GetServerSidePropsContext
) => {
  const { req, query, res } = ctx;
  const { cmp = "" } = query || {};

  const partner = getPartnerOnServerSide(req?.headers);
  const dvid = getDeviceIdForServer(req, res, partner);
  let commonsHeaderData = null;
  if (partner !== PARTNER.GI) {
    const profile =
      partner === PARTNER.MYBIZ
        ? "BUSINESS"
        : partner === PARTNER.MYPARTNER
        ? "CTA"
        : "PERSONAL";
    commonsHeaderData = await getCommonsHeaderData(
      dvid,
      profile,
      req?.cookies?.["mmt-auth"]
    );
  }

  return seoGSSP(
    ctx,
    () => getLandingPageJsonByCountry(query.country ?? "", partner),
    partner,
    cmp,
    commonsHeaderData
  );
};

export default CountryLandingPage;
